import { cache } from 'react';

import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { API } from '../constants/constants';
import { CategoryData } from '../models';

export const apiGetCategoryData = cache(async (path: string, segment: string, signal?: AbortSignal) => {
    const site = segment === TeliaSegment.B2b ? 'teliaB2bWebsite' : 'teliaWebsite';

    return axiosForHybris.get<CategoryData>(withParams(API.URL_CATEGORY, { site }), {
        params: { path },
        signal,
    });
});
